namespace TabAurous.HR {
    export namespace PayrollDetailsService {
        export const baseUrl = 'HR/PayrollDetails';

        export declare function Create(request: Serenity.SaveRequest<PayrollDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PayrollDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PayrollDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PayrollDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetEmployeePayroll(request: HRRequest, onSuccess?: (response: Serenity.ListResponse<PayrollDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "HR/PayrollDetails/Create",
            Update = "HR/PayrollDetails/Update",
            Delete = "HR/PayrollDetails/Delete",
            Retrieve = "HR/PayrollDetails/Retrieve",
            List = "HR/PayrollDetails/List",
            GetEmployeePayroll = "HR/PayrollDetails/GetEmployeePayroll"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetEmployeePayroll'
        ].forEach(x => {
            (<any>PayrollDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
